/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { Fragment, useMemo, useCallback } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import { R50, R500 } from '@atlaskit/theme/colors';
import ErrorIcon from '@atlaskit/icon/core/migration/error';
import { dropdownItemGroupStyles, contentStyles, linkStyles, textStyles } from './styled';
import { getFormattedMessage, openEmbedModalWithFlexibleUiIcon } from '../../../../utils';
import { messages } from '../../../../../../../messages';
import { useFlexibleUiAnalyticsContext } from '../../../../../../../state/flexible-ui-context';
import useResolve from '../../../../../../../state/hooks/use-resolve';
const MAX_LINE_NUMBER = 8;
const LozengeActionError = ({
  errorMessage,
  testId,
  maxLineNumber = MAX_LINE_NUMBER,
  url,
  previewData
}) => {
  const reload = useResolve();
  const analytics = useFlexibleUiAnalyticsContext();
  const isPreviewAvailable = previewData && previewData.src !== undefined;
  const handlePreviewClose = useCallback(() => {
    if (url) {
      reload(url, true);
    }
  }, [reload, url]);
  const handlePreviewOpen = useCallback(() => {
    if (isPreviewAvailable) {
      analytics === null || analytics === void 0 ? void 0 : analytics.ui.smartLinkLozengeActionErrorOpenPreviewClickedEvent();
      return openEmbedModalWithFlexibleUiIcon({
        ...previewData,
        analytics,
        onClose: handlePreviewClose
      });
    }
  }, [analytics, handlePreviewClose, isPreviewAvailable, previewData]);
  const content = useMemo(() => {
    return jsx(Fragment, null, jsx("div", {
      css: contentStyles
    }, jsx(ErrorIcon, {
      testId: `${testId}-icon`,
      LEGACY_size: "medium",
      color: `var(--ds-icon-danger, ${R500})`,
      LEGACY_secondaryColor: `var(--ds-background-danger, ${R50})`,
      label: 'error',
      spacing: "spacious"
    }), jsx("span", {
      css: textStyles(maxLineNumber),
      "data-testid": `${testId}-error-message`
    }, typeof errorMessage === 'string' ? errorMessage : getFormattedMessage(errorMessage))), isPreviewAvailable ?
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    jsx("div", {
      css: linkStyles
    }, jsx("a", {
      target: "_blank",
      "data-testid": `${testId}-open-embed`,
      onClick: handlePreviewOpen
    }, jsx(FormattedMessage, messages.open_issue_in_jira))) : null);
  }, [errorMessage, handlePreviewOpen, isPreviewAvailable, maxLineNumber, testId]);
  return (
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    jsx("span", {
      css: dropdownItemGroupStyles,
      "data-testid": `${testId}-error-item-group`
    }, jsx(DropdownItemGroup, null, jsx(DropdownItem, {
      testId: `${testId}-error`
    }, content)))
  );
};
export default LozengeActionError;